module.exports = __webpack_public_path__ + "static/media/fondo-banner-sup2.51be9f1d.jpg";